var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 17.6715C20.3332 18.1012 20.1576 18.5134 19.845 18.8172C19.5325 19.1211 19.1085 19.2918 18.6665 19.2918H5.33317C4.89114 19.2918 4.46722 19.1211 4.15466 18.8172C3.8421 18.5134 3.6665 18.1012 3.6665 17.6715V6.32887C3.6665 5.89912 3.8421 5.48697 4.15466 5.18309C4.46722 4.87921 4.89114 4.7085 5.33317 4.7085H9.49984L11.1665 7.13905H18.6665C19.1085 7.13905 19.5325 7.30977 19.845 7.61365C20.1576 7.91753 20.3332 8.32967 20.3332 8.75942V17.6715Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.91699V16.167M8.875 13.042H15.125",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/addFolder.001466e77d5c8539465308bc05531d19.svg";
export { ForwardRef as ReactComponent };